import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class DimensionsService {

  constructor(private platform: Platform) { }

  getClientWidth(): number {
    return this.platform.width();
  }
}
